import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import Processing from '../../components/Processing';

import Api from '../../Api';

export default class Code extends React.Component {
  constructor(props) {
    super(props);

    this.onSignIn = this.onSignIn.bind(this);
    this.onRetry = this.onRetry.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      invalidCode: false,
      code: '',
      retried: false
    };
  }

  componentDidMount() {
    if (this.inputField) this.inputField.focus();
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      return this.submitButton.click(event);
    }
  }

  onChange(event) {
    if (event.defaultPrevented) return;

    let initialValue = event.target.value || '';
    let value = initialValue.replace(/\D/g, '');

    this.setState({
      code: value
    });
  }

  onRetry() {
    this.setState({ invalidCode: false });
    Api.userLogin(this.props.params.alias);
    this.setState({ retried: true });
  }

  onSignIn() {
    this.setState({ invalidCode: false });

    return Api.userLogin(this.props.params.alias, this.inputField.value)
      .then(
        (user) => {
          if (!user) {
            this.setState({ invalidCode: true });
          } else {
            let defaultRedirect = user.retailer_token ? `/retailer/${user.retailer_token}` : '/';
            this.context.router.push(this.props.location.query.redirect || defaultRedirect);
          }
        }
      );
  }

  render() {
    let errorMessage = null;

    if (this.state.invalidCode) {
      errorMessage = <div className="error">Invalid code</div>;
    }

    let alias = this.props.params.alias;
    let additionalAlias = alias.indexOf('@') > 0
      ? ' and your phone number'
      : ' and your email address';

    let retry = !this.state.retried
      ? <p className="note">Did not receive a code? <a className="resend-code" href="javascript:void(0)" onClick={this.onRetry}>Send Again.</a></p>
      : null;
    return (
      <div className="page-flyout signin">
        <h2>Sign In</h2>
        <p className="note">Enter the access code we sent to <strong>{alias}</strong>{additionalAlias}.</p>
        <div className="input">
          <input
            autoFocus
            type="text"
            ref={inputField => this.inputField = inputField}
            placeholder="Confirmation Code"
            className="center"
            pattern="\d*"
            value={this.state.code}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
          />
        </div>
        <div className="error-placeholder">
          {errorMessage}
        </div>
        <div>
          <Button
            ref={submitButton => this.submitButton = submitButton}
            onClick={this.onSignIn}
            waitingState={<Processing/>}
          >
            Sign In
          </Button>
          {retry}
        </div>
      </div>
    );
  }
}

Code.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/user/code.js
 **/